import { Pipe, PipeTransform } from '@angular/core'

/**
 * Formats the number of ms to a human-readable.
 * Will round up.
 *
 * ## Example usage
 *
 * 300 = 300ms
 * 1500 = 2 seconds
 * 5000 = 5 seconds
 * 20000 = 20 seconds
 * 60000 = 1 minute
 * 70000 = 2 minutes
 * 2400000 = 40 minutes
 * 6600000 = 2 hours
 * 18000000 = 5 hours
 * 7200000 = 2 hours
 * 108000000 = 2 days
 */
@Pipe({ name: 'ftrMsToHumanReadable', standalone: true })
export class MsToHumanReadablePipe implements PipeTransform {
  transform(ms: number): string {
    if (ms < 1000) {
      return `${ms}ms`
    }

    const s = Math.ceil(ms / 1000)
    if (s < 60) {
      return this.format(s, 'second')
    }

    const m = Math.ceil(s / 60)
    if (m < 60) {
      return this.format(m, 'minute')
    }

    const h = Math.ceil(m / 60)
    if (h < 24) {
      return this.format(h, 'hour')
    }

    const d = Math.ceil(h / 24)
    return this.format(d, 'day')
  }

  private format(num: number, unit: string): string {
    return `${num} ${this.pluralize(unit, num)}`
  }

  private pluralize(unit: string, num: number): string {
    return `${unit}${num === 1 ? '' : 's'}`
  }
}
